<!-- 发票管理 -->
<template>
  <div class="container">
    <div style="margin-bottom: 0.24rem">
      <el-checkbox-group @change="init.page = 1, getQueryInvoiceList()" style="margin-bottom: 0.24rem"
        v-model="init.q.invoicingKinds">
        <el-checkbox v-for="item in checkData" :key="item.label" :label="item.label">{{ item.value }}</el-checkbox>
      </el-checkbox-group>
      <div class="center">
        <div style="display: flex;align-items: center;margin-bottom: 0.12rem;">
          <p class="p1">订单编号:</p>
          <el-input style="width: 1.6rem; margin-right: 0.1rem" size="small" v-model="init.q.orderNumber"
            placeholder="订单编号"></el-input>
          <p class="p1">团号:</p>
          <el-input size="small" style="width: 0.6rem;margin-right: 0.1rem;" v-model="init.q.planId"
            placeholder="团号"></el-input>
          <p class="p1">申请日期:</p>
          <el-date-picker @change="init.page = 1, getQueryInvoiceList()" size="small" value-format="yyyy-MM-dd"
            style="margin-right: 0.05rem;width:1.5rem;" v-model="init.q.createTimeStr" type="date" placeholder="申请日期">
          </el-date-picker>
          <p class="p1">发票金额:</p>
          <el-input size="small" type="number" style="width: 1.1rem;margin-right: 0.1rem;" v-model="init.q.fapPrice"
            placeholder="发票金额"></el-input>
          <p class="p1">抬头类型:</p>
          <el-input style="width: 1.6rem; margin-right: 0.1rem" size="small" v-model="init.q.lookUp"
            placeholder="抬头类型"></el-input>
          <p class="p1">稅号:</p>
          <el-input size="small" style="width: 1.6rem;margin-right: 0.1rem;" v-model="init.q.duty"
            placeholder="稅号"></el-input>
          <p class="p1">发票号码:</p>
          <el-input style="width: 1.6rem; margin-right: 0.1rem" size="small" v-model="init.q.fpNumber"
            placeholder="发票号码"></el-input>
        </div>
        <div style="display: flex;align-items: center;">
          <p class="p1">发票内容:</p>
          <el-input size="small" style="width: 1.6rem;margin-right: 0.1rem;" v-model="init.q.remark"
            placeholder="发票内容"></el-input>
          <p class="p1">发票备注:</p>
          <el-input size="small" style="width: 1.6rem;margin-right: 0.1rem;" v-model="init.q.invoicingRemark"
            placeholder="发票备注"></el-input>
          <p class="p1">开票日期:</p>
          <el-date-picker @change="init.page = 1, getQueryInvoiceList()" size="small" value-format="yyyy-MM-dd"
            style="margin-right: 0.1rem;width:1.5rem;" v-model="init.q.invoicingTimeStr" type="date" placeholder="开票日期">
          </el-date-picker>
          <p class="p1">收款状态:</p>
          <el-select @change="init.page = 1, getQueryInvoiceList()" style="width: 1.6rem; margin-right: 0.1rem"
            size="small" v-model="init.q.linkStatus" placeholder="收款状态">
            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <p class="p1">开票状态:</p>
          <el-select @change="init.page = 1, getQueryInvoiceList()" style="width: 1.6rem; margin-right: 0.1rem"
            size="small" v-model="init.q.kpStatus" placeholder="开票状态">
            <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <p class="p1">申请人:</p>
          <el-input size="small" style="width: 1.6rem;margin-right: 0.1rem;" v-model="init.q.createName"
            placeholder="申请人"></el-input>
          <el-button @click="init.q.page = 1; getQueryInvoiceList()" type="primary" size="small">搜索</el-button>
          <el-button @click="resetClick" size="small">重置</el-button>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <el-radio-group @change="init.page = 1, getQueryInvoiceList()" text-color="#fff" size="small" fill="#E69C37"
          v-model="init.q.status">
          <el-radio-button v-for="item in radioList" :key="item.name" :label="item.code">{{ item.name
            }}</el-radio-button>
        </el-radio-group>
      </div>
      <!-- <div class="right">
        <el-button size="small">导出</el-button>
        <el-button size="small" type="info">删除</el-button>
        <el-button size="small">催促开发票</el-button>
      </div> -->
    </div>
    <el-table show-overflow-tooltip :span-method="objectSpanMethod" border v-loading="loading" ref="multipleTable"
      :data="tableData" tooltip-effect="dark" :header-cell-style="{ color: '#000' }" style="width: 100%;"
      @selection-change="handleSelectionChange">
      <el-table-column prop="pId" fixed="left" align="center" type="selection" width="55"> </el-table-column>
      <el-table-column fixed="left" width="160" prop="pId" align="center" label="订单编号">
        <template slot-scope="scope">
          <p v-for="(item, index) in scope.row.orderIds" :key="index">
            {{ item }}
          </p>
        </template>
      </el-table-column>
      <el-table-column fixed="left" align="center" prop="createTime" label="申请日期" width="170"> </el-table-column>
      <el-table-column width="50" align="center" prop="pId" label="团号">
        <template slot-scope="scope">
          {{ scope.row.planId }}
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" prop="invoicingRemark" show-overflow-tooltip label="发票金额">
        <template slot-scope="scope">
          <span style="color: rgb(216, 27, 67);">{{ '¥' +
            scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" prop="lookUp" show-overflow-tooltip label="抬头">
      </el-table-column>
      <el-table-column width="150" align="center" prop="duty" show-overflow-tooltip label="税号">
      </el-table-column>
      <el-table-column width="150" align="center" prop="fpNumber" show-overflow-tooltip label="发票号码">
      </el-table-column>
      <el-table-column align="center" prop="remark" show-overflow-tooltip label="发票内容" width="150">
      </el-table-column>
      <el-table-column width="150" align="center" prop="pId" show-overflow-tooltip label="发票备注">
        <template slot-scope="scope">
          {{ scope.row.invoicingRemark }}
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" prop="createTime" show-overflow-tooltip label="开票时间">
      </el-table-column>
      <!-- <el-table-column width="150" align="center" prop="invoicingRemark" show-overflow-tooltip label="财务备注">
            </el-table-column> -->
      <el-table-column align="center" prop="linkStatus" show-overflow-tooltip label="收款状态">
        <template slot-scope="scope">
          {{ linkStatusMap[scope.row.linkStatus] }}
        </template>
      </el-table-column>
      <el-table-column width="250" align="center" label="开票状态">
        <template slot-scope="scope">
          <el-tag :type="statusMap[scope.row.status].type">{{ statusMap[scope.row.status].text }}</el-tag>
          <span v-if="!scope.row.status && scope.row.fileUrl">（已产生开票信息）</span>
          <div v-if="scope.row.status == 2">
            驳回理由：{{ scope.row.rejectReason }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="pId" show-overflow-tooltip label="申请人" width="100">
        <template slot-scope="scope">
          {{ scope.row.createName }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="100" align="center" label="下载">
        <template slot-scope="scope">
          <!-- !Boolean(scope.row.status == 1) -->
          <el-button :disabled="!scope.row.fileUrl" @click="downloadFile(scope.row.fileUrl, scope.row.fileKey)"
            size="mini" type="success">发票下载 <a :id="'d' + scope.$index"></a></el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" prop="pId" width="100" align="center" label="撤回">
        <template slot-scope="scope">
          <el-button @click="withdraw(scope.row.pId)"
            :disabled="datas.find(n => n.id === scope.row.pId).invoicingDetailList.some(n => n.status === 1 || n.fileUrl || n.status === 2)"
            size="mini" type="primary">发票撤回</el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="100" align="center" label="作废">
        <template slot-scope="scope">
            <el-tooltip :disabled="scope.row.status === 1" class="item" effect="dark" content="后台设置成已开票,才能申请发票作废" placement="top-start">
              <el-button @click="invoiceVoid(scope.row.id)" :disabled="scope.row.status !== 1" size="mini"
                type="warning">申请发票作废</el-button>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" show-overflow-tooltip label="关联操作" width="100">
        <template slot-scope="scope">
          <el-button @click="changeAssociation(scope.row.id,scope.row.price,scope.row.planId)" size="mini"
          type="primary">更改关联</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
      @loadTable='loadTable'></Pagination>
      <changeAssociationPopup @update="getQueryInvoiceList" ref="changeAssociationPopup"></changeAssociationPopup>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import Api from "../../../../components/Api";
import { uniqueByProperty, download } from '@/assets/utils/unit'
import changeAssociationPopup from "./changeAssociationPopup.vue";
export default {
  components: {
    Pagination,
    changeAssociationPopup
  },
  data() {
    return {
      input: "",
      value: "",
      pageSizes: [10, 20, 25, 30],
      loading: true,
      AllpagesNum: 0,
      tableData: [],
      linkStatusMap: {
        '0': '未收款',
        '1': '已收款',
        '2': '已到账未结算',
        '3': '申请退款',
        '4': '退款成功',
      },
      invoiceType: {
        0: '企业',
        1: '个人',
        2: '非企业性单位'
      },
      "init": {
        "page": 1,
        "q": {
          "id": null,
          "status": null,
          "invoicingKinds": [],
          "orderNumber": null,//订单编号
          "createTimeStr": null,//申请日期
          "planId": null,//团号
          "fapPrice": null,//发票金额
          "lookUp": null,//发票抬头
          "duty": null,//稅号
          "fpNumber": null,//发票号码
          "remark": null,//发票内容
          "invoicingRemark": null,//发票备注
          "invoicingTimeStr": null,//开票时间
          "linkStatus": null,//发票状态
          "kpStatus": null,//开票状态
          "createName": null,//申请人
        },
        "size": 10
      },
      statusMap: {
        0: {
          text: '待开票',
          type: ''
        },
        1: {
          text: '已开票',
          type: 'success'
        },
        2: {
          text: '已驳回',
          type: 'danger'
        },
        3: {
          text: '申请发票作废中...',
          type: 'warning'
        },
        4: {
          text: '发票已作废',
          type: 'info'
        }
      },
      radioList: [
        {
          name: '全部',
          code: null,
        },
        {
          name: '待开票',
          code: 0,
        },
        {
          name: '已开票',
          code: 1,
        },
        {
          name: '已驳回',
          code: 2,
        },
        // {
        //   name: '借发票',
        //   code: 3,
        // }
      ],
      datas: [],
      checkData: [
        {
          value: "单张发票对应单张订单",
          label: "0",
        },
        {
          value: "单张发票对应多张订单",
          label: "1",
        },
        {
          value: "多张发票对应单张订单",
          label: "2",
        },
      ],
      options: [
        {
          value: "1",
          label: "增值税普通发票-电子",
        },
        {
          value: "2",
          label: "增值税普通发票-纸张",
        },
        {
          value: "3",
          label: "增值税专用发票-纸张",
        },
      ],
      options1: [
        {
          value: "0",
          label: "已支付",
        },
        {
          value: "1",
          label: "未支付",
        },
        {
          value: "2",
          label: "已到账未结算",
        },
        {
          value: "3",
          label: "申请退款",
        },
        {
          value: "4",
          label: "退款成功",
        },
      ],
      options2: [
        {
          value: "0",
          label: "待开票",
        },
        {
          value: "1",
          label: "已开票",
        },
        {
          value: "2",
          label: "已驳回",
        },
      ],
      mergeObj: {},
      mergeArr: ['createTime', 'pId'],
    };
  },
  computed: {},
  methods: {
    changeAssociation(id,price,planId) {
      this.$refs.changeAssociationPopup.openDialog(id,price,planId)
    },
    resetClick() {
      this.init.q = {
        "id": null,
        "status": null,
        "invoicingKinds": [],
        "orderNumber": null,//订单编号
        "createTimeStr": null,//申请日期
        "planId": null,//团号
        "fapPrice": null,//发票金额
        "lookUp": null,//发票抬头
        "duty": null,//稅号
        "fpNumber": null,//发票号码
        "remark": null,//发票内容
        "invoicingRemark": null,//发票备注
        "invoicingTimeStr": null,//开票时间
        "linkStatus": null,//发票状态
        "kpStatus": null,//开票状态
        "createName": null,//申请人
      },
        this.init.page = 1
      this.getQueryInvoiceList()
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.mergeArr.indexOf(column.property) !== -1) {
        if (this.mergeObj[column.property][rowIndex]) {
          return [this.mergeObj[column.property][rowIndex], 1]
        } else {
          return [0, 0];
        }
      }
    },
    //发票作废
    invoiceVoid(id) {
      new Api("user")
        .updateByIdToFpNumber({ id, status: 3 })
        .then((res) => {
          if (res.status == 200) {
            this.$message({
              type: 'success',
              message: '申请成功！'
            });
            this.getQueryInvoiceList()
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    //发票撤回
    withdraw(id) {
      this.$confirm('您确定撤回已开发票吗?, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new Api("user").withdrawInvoice(id).then((res) => {
          if (res.status == 200) {
            this.$message({
              type: 'success',
              message: '撤回成功!'
            });
            this.getQueryInvoiceList()
          } else {
            this.$message({
              type: 'success',
              message: res.statusText
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消撤回'
        });
      });
    },
    //文件下载
    downloadFile(urls, name) {
      download(urls, name)
    },
    getSpanArr(data) {
      this.mergeArr.forEach((key, index1) => {
        let count = 0; // 用来记录需要合并行的起始位置
        this.mergeObj[key] = []; // 记录每一列的合并信息
        data.forEach((item, index) => {
          // index == 0表示数据为第一行，直接 push 一个 1
          if (index === 0) {
            this.mergeObj[key].push(1);
          } else {
            // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
            if (item[key] === data[index - 1][key]) {
              this.mergeObj[key][count] += 1;
              this.mergeObj[key].push(0);
            } else {
              // 如果当前行和上一行其值不相等 
              count = index; // 记录当前位置 
              this.mergeObj[key].push(1); // 重新push 一个 1
            }
          }
        })
        console.log(this.mergeObj, '时刻打开打开');
      })
    },
    handleSelectionChange() { },
    //查询发票列表接口
    getQueryInvoiceList() {
      new Api("user")
        .queryInvoice(this.init)
        .then((res) => {
          if (res.status === 200) {
            this.AllpagesNum = res.data.total
            this.datas = uniqueByProperty([...this.datas, ...res.data.records], 'id')
            const mergedList = res.data.records.map(item => {
              const { orderIds, createName, createTime, email,invoicingContent, invoicingKind, invoicingPartyName, invoicingRemark, invoicingType, state, planId } = item;
              const pId = item.id
              const invoicingDetailList = item.invoicingDetailList.map(detailItem => ({
                ...detailItem,
                orderIds, createName, createTime, email,invoicingContent, invoicingKind, invoicingPartyName, invoicingRemark, invoicingType, state, pId, planId
              }));
              return invoicingDetailList;
            });
              console.log(mergedList,'askdksdkdkkdsk')
            // 使用 concat 将所有内部数组合并成一个数组
            this.tableData = [].concat(...mergedList);
            this.getSpanArr(this.tableData);
            this.loading = false
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    loadTable(page, size) {
      this.init.size = size
      this.init.page = page
      this.loading = true
      this.getQueryInvoiceList()
    },
  },
  created() { },
  mounted() {
    setTimeout(() => {
      this.getQueryInvoiceList()
    })
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  padding: 0.24rem;

  .p1 {
    font-size: 0.12rem;
  }

  .center {
    padding: 0.2rem;
    background-color: #f1f1f1;
    display: flex;
    flex-direction: column;

    p {
      margin-right: 0.1rem;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
